import { db } from "./../firebase";
import {
  doc,
  setDoc,
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import sizeof from "firestore-size";

const relatedTable = [
  "ChecklistTemplates",
  "Checklists",
  "Comments",
  "Contacts",
  "Equipment",
  "ExportTemplates",
  "Files",
  "Issues",
  "Observations",
];

async function saveDocument(tablePath, feature) {
  const docRef = doc(collection(db, tablePath), feature.id);
  await setDoc(docRef, feature);
}

async function addNewSubItem(tablePath, parentId, childObj) {
  const docRef = await addDoc(
    collection(db, tablePath, parentId, "projectStore"),
    childObj,
  );
  return docRef.id;
}

async function updateSubItem(tablePath, parentId, childId, childObj) {
  // Create a reference to the specific subdocument
  const subDocRef = doc(
    db,
    tablePath, // Name of the top-level collection
    parentId, // ID of the parent document
    "projectStore", // Name of the subcollection
    childId, // ID of the specific subdocument
  );

  // Update specific fields in the subdocument
  await updateDoc(subDocRef, childObj);
}

const deleteSubcollectionDocById = async (tablePath, parentDocId, subDocId) => {
  const docRef = doc(
    db,
    tablePath, // Name of the top-level collection
    parentDocId,
    "projectStore",
    subDocId,
  );

  // 2. Delete the document using the reference.
  await deleteDoc(docRef);
};

const splitUpProject = (feature, bytes) => {
  var subItems = [];
  var currentSubItem = {};
  const groupSize = 10;

  while (bytes > 1000000) {
    // Condition to check before each iteration
    for (let i = 0; i < relatedTable.length; i++) {
      const tableName = relatedTable[i];

      //this will split the related table into subcollections of 10 items until the size is under 1mb
      if (bytes > 1000000) {
        while (feature[tableName].length > groupSize && bytes > 1000000) {
          currentSubItem[tableName] = currentSubItem.hasOwnProperty(tableName)
            ? [
                ...currentSubItem[tableName],
                ...feature[tableName].slice(0, groupSize),
              ]
            : feature[tableName].slice(0, groupSize);
          feature[tableName] = feature[tableName].slice(groupSize);

          const sizeOfSubItem = sizeof(currentSubItem);
          if (sizeOfSubItem > 850000) {
            subItems.push(currentSubItem);
            currentSubItem = {};
          }
          bytes = sizeof(feature);
        }
      }
    }
  }

  //push in the remaining item if it has any data
  if (Object.keys(currentSubItem).length > 0) {
    subItems.push(currentSubItem);
  }

  return { feature, subItems };
};

export async function saveToFirestore(tablePath, feature) {
  var bytes = sizeof(feature);
  console.log(bytes > 1000000 ? "I'm in awe of the size of this lad!" : "Ew..");
  console.log(`Project size in bytes: ${bytes}`);
  console.log(
    `Project size in percent: ${((bytes / 1000000) * 100).toFixed(2)}%`,
  );
  if (bytes > 1000000) {
    console.log("document size to large");
    const resu = splitUpProject(feature, bytes);
    var splitFeature = resu.feature;
    const subItems = resu.subItems;

    const existingRelatedIds = splitFeature.projectStore_ids;
    var currentIDs = [];

    console.log(`Split feature: ${splitFeature.id}`);
    console.log(`Sub-items count: ${subItems.length}`);
    for (let i = 0; i < subItems.length; i++) {
      var subItem = subItems[i];

      //temporary log to check if the sub-item has the equipment array and how many items it has
      if (subItems[i].hasOwnProperty("Equipment")) {
        console.log(
          `Sub-item ${i} has ${subItems[i].Equipment.length} equipment items.`,
        );
      }

      if (i < existingRelatedIds.length) {
        subItem.id = existingRelatedIds[i];
        currentIDs.push(existingRelatedIds[i]);
        console.log(`Updating sub-item with ID: ${existingRelatedIds[i]}`);
        await updateSubItem(tablePath, splitFeature.id, subItem.id, subItem);
      } else {
        const relatedId = await addNewSubItem(
          tablePath,
          splitFeature.id,
          subItem,
        );
        console.log(`Added new sub-item with ID: ${relatedId}`);
        currentIDs.push(relatedId);
      }
    }

    // Delete any remaining sub-items that are no longer needed
    if (existingRelatedIds.length > currentIDs.length) {
      for (var i = currentIDs.length; i < existingRelatedIds.length; i++) {
        console.log(`Deleting sub-item with ID: ${existingRelatedIds[i]}`);
        await deleteSubcollectionDocById(
          tablePath,
          splitFeature.id,
          existingRelatedIds[i],
        );
      }
    }

    splitFeature.projectStore_ids = currentIDs;

    await saveDocument(tablePath, splitFeature);
  } else {
    await saveDocument(tablePath, feature);
  }
}
